// extracted by mini-css-extract-plugin
export var grid = "modal-module--grid--0af46";
export var gridWithRowGap = "modal-module--grid--with-row-gap--a8c8c";
export var maxWidthContainer = "modal-module--max-width-container--cd493";
export var modal = "modal-module--modal--0889a";
export var modal__close = "modal-module--modal__close--598ea";
export var modal__close__icon = "modal-module--modal__close__icon--b96c4";
export var modal__content = "modal-module--modal__content--39818";
export var modal__contentAuto = "modal-module--modal__content--auto--087bc";
export var modal__contentPopup = "modal-module--modal__content--popup--86b9d";
export var modal__contentPortrait = "modal-module--modal__content--portrait--1b86e";
export var mt0 = "modal-module--mt-0--b9482";
export var mt1 = "modal-module--mt-1--197b2";
export var mt2 = "modal-module--mt-2--4e4a5";
export var mt3 = "modal-module--mt-3--24a5f";
export var mt4 = "modal-module--mt-4--54853";
export var mt5 = "modal-module--mt-5--da643";
export var mt6 = "modal-module--mt-6--e2956";
export var popupModal = "modal-module--popupModal--2df6e";
export var removeVisuallyHidden = "modal-module--remove-visually-hidden--abd2c";
export var visuallyHidden = "modal-module--visually-hidden--fc923";
export var widgetBase = "modal-module--widget-base--a5359";